import { render, staticRenderFns } from "./field.vue?vue&type=template&id=2621cff4&scoped=true&"
import script from "./field.vue?vue&type=script&lang=js&"
export * from "./field.vue?vue&type=script&lang=js&"
import style0 from "./field.vue?vue&type=style&index=0&id=2621cff4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2621cff4",
  null
  
)

export default component.exports